import { render } from "./CHT_Window.vue?vue&type=template&id=60055400"
import script from "./CHT_Window.vue?vue&type=script&lang=js"
export * from "./CHT_Window.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__